/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    ControlBulkReassignmentParams,
    ControlId,
    ControlOverviewListDto,
    ControlResourceCount,
    ControlSchedulingAndSteps,
    ControlUpdateFailedErrorDetails,
    ControlWithFieldsView,
    ControlWithFieldsViewDto,
    ControlWithFieldsViewListDto,
    ControlWithoutFieldsGraphItemDtoListDto,
    CreatableControlBody,
    CreateControlsErrorPayload,
    EditControlDescriptionResponse,
    EditControlDescriptionWithAiParams,
    GetControlsParams,
    NewControlWithFieldsViewDto,
    NextOccurrence,
    PatchControlsControlIdParams,
    PostControlsNewParams,
    PostControlsParams,
    ReducedLegacyControl,
    SuggestTasksParams,
    SuggestedTasks,
    TriggerCompatibleControlDtoListDto,
    TriggerCompatibleControlsRequestDto,
    UpdatableControlBody,
    UpdatableControls,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getAllControls = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlOverviewListDto>> => {
    return axios.get(`/api/all_controls`, options);
};

export const getGetAllControlsQueryKey = () => {
    return [`/api/all_controls`] as const;
};

export const getGetAllControlsQueryOptions = <
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getAllControls>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllControlsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getAllControls>>
    > = ({ signal }) => getAllControls({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getAllControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllControlsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAllControls>>
>;
export type GetAllControlsQueryError = AxiosError<unknown>;

export function useGetAllControls<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAllControls>>,
                    TError,
                    Awaited<ReturnType<typeof getAllControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllControls<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getAllControls>>,
                    TError,
                    Awaited<ReturnType<typeof getAllControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllControls<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllControls<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetAllControlsQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAllControlsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getAllControls>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllControlsQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getAllControls>>
    > = ({ signal }) => getAllControls({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllControlsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAllControls>>
>;
export type GetAllControlsSuspenseQueryError = AxiosError<unknown>;

export function useGetAllControlsSuspense<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllControlsSuspense<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllControlsSuspense<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetAllControlsSuspense<
    TData = Awaited<ReturnType<typeof getAllControls>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetAllControlsSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlsControlId = (
    controlId: ControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithFieldsViewDto>> => {
    return axios.get(`/api/controls/${controlId}`, options);
};

export const getGetControlsControlIdQueryKey = (controlId: ControlId) => {
    return [`/api/controls/${controlId}`] as const;
};

export const getGetControlsControlIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlsControlIdQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlId>>
    > = ({ signal }) =>
        getControlsControlId(controlId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: controlId !== null && controlId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlId>>
>;
export type GetControlsControlIdQueryError = AxiosError<unknown>;

export function useGetControlsControlId<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlId>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlId<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlId>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlId<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlId<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdQueryOptions(
        controlId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlsControlIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlsControlIdQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlId>>
    > = ({ signal }) =>
        getControlsControlId(controlId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlId>>
>;
export type GetControlsControlIdSuspenseQueryError = AxiosError<unknown>;

export function useGetControlsControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlIdSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlId>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdSuspenseQueryOptions(
        controlId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const deleteControlsControlId = (
    controlId: ControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.delete(`/api/controls/${controlId}`, options);
};

export const getDeleteControlsControlIdMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteControlsControlId>>,
        TError,
        { controlId: ControlId },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteControlsControlId>>,
    TError,
    { controlId: ControlId },
    TContext
> => {
    const mutationKey = ["deleteControlsControlId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteControlsControlId>>,
        { controlId: ControlId }
    > = (props) => {
        const { controlId } = props ?? {};

        return deleteControlsControlId(controlId, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type DeleteControlsControlIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteControlsControlId>>
>;

export type DeleteControlsControlIdMutationError = AxiosError<unknown>;

export const useDeleteControlsControlId = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteControlsControlId>>,
            TError,
            { controlId: ControlId },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof deleteControlsControlId>>,
    TError,
    { controlId: ControlId },
    TContext
> => {
    return useMutation(
        getDeleteControlsControlIdMutationOptions(options),
        queryClient
    );
};
export const patchControlsControlId = (
    controlId: ControlId,
    updatableControlBody: UpdatableControlBody,
    params?: PatchControlsControlIdParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithFieldsView>> => {
    return axios.patch(`/api/controls/${controlId}`, updatableControlBody, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPatchControlsControlIdMutationOptions = <
    TError = AxiosError<ControlUpdateFailedErrorDetails>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchControlsControlId>>,
        TError,
        {
            controlId: ControlId;
            data: UpdatableControlBody;
            params?: PatchControlsControlIdParams;
        },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchControlsControlId>>,
    TError,
    {
        controlId: ControlId;
        data: UpdatableControlBody;
        params?: PatchControlsControlIdParams;
    },
    TContext
> => {
    const mutationKey = ["patchControlsControlId"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchControlsControlId>>,
        {
            controlId: ControlId;
            data: UpdatableControlBody;
            params?: PatchControlsControlIdParams;
        }
    > = (props) => {
        const { controlId, data, params } = props ?? {};

        return patchControlsControlId(controlId, data, params, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchControlsControlIdMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchControlsControlId>>
>;
export type PatchControlsControlIdMutationBody = UpdatableControlBody;
export type PatchControlsControlIdMutationError =
    AxiosError<ControlUpdateFailedErrorDetails>;

export const usePatchControlsControlId = <
    TError = AxiosError<ControlUpdateFailedErrorDetails>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchControlsControlId>>,
            TError,
            {
                controlId: ControlId;
                data: UpdatableControlBody;
                params?: PatchControlsControlIdParams;
            },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchControlsControlId>>,
    TError,
    {
        controlId: ControlId;
        data: UpdatableControlBody;
        params?: PatchControlsControlIdParams;
    },
    TContext
> => {
    return useMutation(
        getPatchControlsControlIdMutationOptions(options),
        queryClient
    );
};
export const getControlsControlIdLegacy = (
    controlId: ControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ReducedLegacyControl>> => {
    return axios.get(`/api/controls/${controlId}/legacy`, options);
};

export const getGetControlsControlIdLegacyQueryKey = (controlId: ControlId) => {
    return [`/api/controls/${controlId}/legacy`] as const;
};

export const getGetControlsControlIdLegacyQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlsControlIdLegacyQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlIdLegacy>>
    > = ({ signal }) =>
        getControlsControlIdLegacy(controlId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: controlId !== null && controlId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdLegacyQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlIdLegacy>>
>;
export type GetControlsControlIdLegacyQueryError = AxiosError<unknown>;

export function useGetControlsControlIdLegacy<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlIdLegacy>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdLegacy<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlIdLegacy>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdLegacy<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlIdLegacy<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdLegacyQueryOptions(
        controlId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlsControlIdLegacySuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlsControlIdLegacyQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlIdLegacy>>
    > = ({ signal }) =>
        getControlsControlIdLegacy(controlId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdLegacySuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlIdLegacy>>
>;
export type GetControlsControlIdLegacySuspenseQueryError = AxiosError<unknown>;

export function useGetControlsControlIdLegacySuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdLegacySuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdLegacySuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlIdLegacySuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdLegacy>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdLegacySuspenseQueryOptions(
        controlId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControlsControlIdReport = (
    controlId: ControlId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<unknown>> => {
    return axios.get(`/api/controls/${controlId}/report`, options);
};

export const getGetControlsControlIdReportQueryKey = (controlId: ControlId) => {
    return [`/api/controls/${controlId}/report`] as const;
};

export const getGetControlsControlIdReportQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlsControlIdReportQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlIdReport>>
    > = ({ signal }) =>
        getControlsControlIdReport(controlId, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: controlId !== null && controlId !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlIdReport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdReportQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlIdReport>>
>;
export type GetControlsControlIdReportQueryError = AxiosError<unknown>;

export function useGetControlsControlIdReport<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlIdReport>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlIdReport>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdReport<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsControlIdReport>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsControlIdReport>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdReport<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlIdReport<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdReportQueryOptions(
        controlId,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlsControlIdReportSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getGetControlsControlIdReportQueryKey(controlId);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsControlIdReport>>
    > = ({ signal }) =>
        getControlsControlIdReport(controlId, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlsControlIdReport>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsControlIdReportSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsControlIdReport>>
>;
export type GetControlsControlIdReportSuspenseQueryError = AxiosError<unknown>;

export function useGetControlsControlIdReportSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdReportSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsControlIdReportSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsControlIdReportSuspense<
    TData = Awaited<ReturnType<typeof getControlsControlIdReport>>,
    TError = AxiosError<unknown>,
>(
    controlId: ControlId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsControlIdReport>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsControlIdReportSuspenseQueryOptions(
        controlId,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getControls = (
    params?: GetControlsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithoutFieldsGraphItemDtoListDto>> => {
    return axios.get(`/api/controls`, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getGetControlsQueryKey = (params?: GetControlsParams) => {
    return [`/api/controls`, ...(params ? [params] : [])] as const;
};

export const getGetControlsQueryOptions = <
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetControlsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControls>>> = ({
        signal,
    }) => getControls(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControls>>
>;
export type GetControlsQueryError = AxiosError<unknown>;

export function useGetControls<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetControlsParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControls>>,
                    TError,
                    Awaited<ReturnType<typeof getControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControls<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControls>>,
                    TError,
                    Awaited<ReturnType<typeof getControls>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControls<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControls<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetControlsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getControls>>> = ({
        signal,
    }) => getControls(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControls>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControls>>
>;
export type GetControlsSuspenseQueryError = AxiosError<unknown>;

export function useGetControlsSuspense<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | GetControlsParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsSuspense<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsSuspense<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsSuspense<
    TData = Awaited<ReturnType<typeof getControls>>,
    TError = AxiosError<unknown>,
>(
    params?: GetControlsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControls>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControls = (
    creatableControlBody: CreatableControlBody,
    params?: PostControlsParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithFieldsView>> => {
    return axios.post(`/api/controls`, creatableControlBody, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostControlsMutationOptions = <
    TError = AxiosError<CreateControlsErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControls>>,
        TError,
        { data: CreatableControlBody; params?: PostControlsParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControls>>,
    TError,
    { data: CreatableControlBody; params?: PostControlsParams },
    TContext
> => {
    const mutationKey = ["postControls"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControls>>,
        { data: CreatableControlBody; params?: PostControlsParams }
    > = (props) => {
        const { data, params } = props ?? {};

        return postControls(data, params, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlsMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControls>>
>;
export type PostControlsMutationBody = CreatableControlBody;
export type PostControlsMutationError = AxiosError<CreateControlsErrorPayload>;

export const usePostControls = <
    TError = AxiosError<CreateControlsErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControls>>,
            TError,
            { data: CreatableControlBody; params?: PostControlsParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControls>>,
    TError,
    { data: CreatableControlBody; params?: PostControlsParams },
    TContext
> => {
    return useMutation(getPostControlsMutationOptions(options), queryClient);
};
export const patchControls = (
    updatableControls: UpdatableControls,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
    return axios.patch(`/api/controls`, updatableControls, options);
};

export const getPatchControlsMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchControls>>,
        TError,
        { data: UpdatableControls },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchControls>>,
    TError,
    { data: UpdatableControls },
    TContext
> => {
    const mutationKey = ["patchControls"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchControls>>,
        { data: UpdatableControls }
    > = (props) => {
        const { data } = props ?? {};

        return patchControls(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchControlsMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchControls>>
>;
export type PatchControlsMutationBody = UpdatableControls;
export type PatchControlsMutationError = AxiosError<unknown>;

export const usePatchControls = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchControls>>,
            TError,
            { data: UpdatableControls },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchControls>>,
    TError,
    { data: UpdatableControls },
    TContext
> => {
    return useMutation(getPatchControlsMutationOptions(options), queryClient);
};
export const postControlsBulk = (
    controlWithFieldsView: ControlWithFieldsView[],
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithFieldsView[]>> => {
    return axios.post(`/api/controls/bulk`, controlWithFieldsView, options);
};

export const getPostControlsBulkMutationOptions = <
    TError = AxiosError<CreateControlsErrorPayload>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlsBulk>>,
        TError,
        { data: ControlWithFieldsView[] },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlsBulk>>,
    TError,
    { data: ControlWithFieldsView[] },
    TContext
> => {
    const mutationKey = ["postControlsBulk"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlsBulk>>,
        { data: ControlWithFieldsView[] }
    > = (props) => {
        const { data } = props ?? {};

        return postControlsBulk(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlsBulkMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlsBulk>>
>;
export type PostControlsBulkMutationBody = ControlWithFieldsView[];
export type PostControlsBulkMutationError =
    AxiosError<CreateControlsErrorPayload>;

export const usePostControlsBulk = <
    TError = AxiosError<CreateControlsErrorPayload>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlsBulk>>,
            TError,
            { data: ControlWithFieldsView[] },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlsBulk>>,
    TError,
    { data: ControlWithFieldsView[] },
    TContext
> => {
    return useMutation(
        getPostControlsBulkMutationOptions(options),
        queryClient
    );
};
export const patchControlsBulkReassign = (
    controlBulkReassignmentParams: ControlBulkReassignmentParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlWithFieldsViewListDto>> => {
    return axios.patch(
        `/api/controls/bulk-reassign`,
        controlBulkReassignmentParams,
        options
    );
};

export const getPatchControlsBulkReassignMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof patchControlsBulkReassign>>,
        TError,
        { data: ControlBulkReassignmentParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof patchControlsBulkReassign>>,
    TError,
    { data: ControlBulkReassignmentParams },
    TContext
> => {
    const mutationKey = ["patchControlsBulkReassign"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof patchControlsBulkReassign>>,
        { data: ControlBulkReassignmentParams }
    > = (props) => {
        const { data } = props ?? {};

        return patchControlsBulkReassign(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PatchControlsBulkReassignMutationResult = NonNullable<
    Awaited<ReturnType<typeof patchControlsBulkReassign>>
>;
export type PatchControlsBulkReassignMutationBody =
    ControlBulkReassignmentParams;
export type PatchControlsBulkReassignMutationError = AxiosError<unknown>;

export const usePatchControlsBulkReassign = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof patchControlsBulkReassign>>,
            TError,
            { data: ControlBulkReassignmentParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof patchControlsBulkReassign>>,
    TError,
    { data: ControlBulkReassignmentParams },
    TContext
> => {
    return useMutation(
        getPatchControlsBulkReassignMutationOptions(options),
        queryClient
    );
};
export const postControlsCompatibleTriggering = (
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<TriggerCompatibleControlDtoListDto>> => {
    return axios.post(
        `/api/controls/compatible_triggering`,
        triggerCompatibleControlsRequestDto,
        options
    );
};

export const getPostControlsCompatibleTriggeringQueryKey = (
    triggerCompatibleControlsRequestDto?: TriggerCompatibleControlsRequestDto
) => {
    return [
        "POST",
        `/api/controls/compatible_triggering`,
        triggerCompatibleControlsRequestDto,
    ] as const;
};

export const getPostControlsCompatibleTriggeringQueryOptions = <
    TData = Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
    TError = AxiosError<unknown>,
>(
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getPostControlsCompatibleTriggeringQueryKey(
            triggerCompatibleControlsRequestDto
        );

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof postControlsCompatibleTriggering>>
    > = ({ signal }) =>
        postControlsCompatibleTriggering(triggerCompatibleControlsRequestDto, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostControlsCompatibleTriggeringQueryResult = NonNullable<
    Awaited<ReturnType<typeof postControlsCompatibleTriggering>>
>;
export type PostControlsCompatibleTriggeringQueryError = AxiosError<unknown>;

export function usePostControlsCompatibleTriggering<
    TData = Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
    TError = AxiosError<unknown>,
>(
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof postControlsCompatibleTriggering>
                    >,
                    TError,
                    Awaited<ReturnType<typeof postControlsCompatibleTriggering>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsCompatibleTriggering<
    TData = Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
    TError = AxiosError<unknown>,
>(
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<
                        ReturnType<typeof postControlsCompatibleTriggering>
                    >,
                    TError,
                    Awaited<ReturnType<typeof postControlsCompatibleTriggering>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsCompatibleTriggering<
    TData = Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
    TError = AxiosError<unknown>,
>(
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostControlsCompatibleTriggering<
    TData = Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
    TError = AxiosError<unknown>,
>(
    triggerCompatibleControlsRequestDto: TriggerCompatibleControlsRequestDto,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsCompatibleTriggering>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getPostControlsCompatibleTriggeringQueryOptions(
        triggerCompatibleControlsRequestDto,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlsAiEditDescription = (
    editControlDescriptionWithAiParams: EditControlDescriptionWithAiParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<EditControlDescriptionResponse>> => {
    return axios.post(
        `/api/controls/ai-edit-description`,
        editControlDescriptionWithAiParams,
        options
    );
};

export const getPostControlsAiEditDescriptionMutationOptions = <
    TError = AxiosError<null>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlsAiEditDescription>>,
        TError,
        { data: EditControlDescriptionWithAiParams },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlsAiEditDescription>>,
    TError,
    { data: EditControlDescriptionWithAiParams },
    TContext
> => {
    const mutationKey = ["postControlsAiEditDescription"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlsAiEditDescription>>,
        { data: EditControlDescriptionWithAiParams }
    > = (props) => {
        const { data } = props ?? {};

        return postControlsAiEditDescription(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlsAiEditDescriptionMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlsAiEditDescription>>
>;
export type PostControlsAiEditDescriptionMutationBody =
    EditControlDescriptionWithAiParams;
export type PostControlsAiEditDescriptionMutationError = AxiosError<null>;

export const usePostControlsAiEditDescription = <
    TError = AxiosError<null>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlsAiEditDescription>>,
            TError,
            { data: EditControlDescriptionWithAiParams },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlsAiEditDescription>>,
    TError,
    { data: EditControlDescriptionWithAiParams },
    TContext
> => {
    return useMutation(
        getPostControlsAiEditDescriptionMutationOptions(options),
        queryClient
    );
};
export const postControlsAiSuggestTasks = (
    suggestTasksParams: SuggestTasksParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<SuggestedTasks | null>> => {
    return axios.post(
        `/api/controls/ai-suggest-tasks`,
        suggestTasksParams,
        options
    );
};

export const getPostControlsAiSuggestTasksQueryKey = (
    suggestTasksParams?: SuggestTasksParams
) => {
    return [
        "POST",
        `/api/controls/ai-suggest-tasks`,
        suggestTasksParams,
    ] as const;
};

export const getPostControlsAiSuggestTasksQueryOptions = <
    TData = Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
    TError = AxiosError<null>,
>(
    suggestTasksParams: SuggestTasksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getPostControlsAiSuggestTasksQueryKey(suggestTasksParams);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof postControlsAiSuggestTasks>>
    > = ({ signal }) =>
        postControlsAiSuggestTasks(suggestTasksParams, {
            signal,
            ...axiosOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostControlsAiSuggestTasksQueryResult = NonNullable<
    Awaited<ReturnType<typeof postControlsAiSuggestTasks>>
>;
export type PostControlsAiSuggestTasksQueryError = AxiosError<null>;

export function usePostControlsAiSuggestTasks<
    TData = Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
    TError = AxiosError<null>,
>(
    suggestTasksParams: SuggestTasksParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                    TError,
                    Awaited<ReturnType<typeof postControlsAiSuggestTasks>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsAiSuggestTasks<
    TData = Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
    TError = AxiosError<null>,
>(
    suggestTasksParams: SuggestTasksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                    TError,
                    Awaited<ReturnType<typeof postControlsAiSuggestTasks>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsAiSuggestTasks<
    TData = Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
    TError = AxiosError<null>,
>(
    suggestTasksParams: SuggestTasksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostControlsAiSuggestTasks<
    TData = Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
    TError = AxiosError<null>,
>(
    suggestTasksParams: SuggestTasksParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsAiSuggestTasks>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getPostControlsAiSuggestTasksQueryOptions(
        suggestTasksParams,
        options
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlsNew = (
    params?: PostControlsNewParams,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<NewControlWithFieldsViewDto>> => {
    return axios.post(`/api/controls/new`, undefined, {
        paramsSerializer: { indexes: null },
        ...options,
        params: { ...params, ...options?.params },
    });
};

export const getPostControlsNewQueryKey = (params?: PostControlsNewParams) => {
    return ["POST", `/api/controls/new`, ...(params ? [params] : [])] as const;
};

export const getPostControlsNewQueryOptions = <
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getPostControlsNewQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof postControlsNew>>
    > = ({ signal }) => postControlsNew(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof postControlsNew>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostControlsNewQueryResult = NonNullable<
    Awaited<ReturnType<typeof postControlsNew>>
>;
export type PostControlsNewQueryError = AxiosError<unknown>;

export function usePostControlsNew<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | PostControlsNewParams,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postControlsNew>>,
                    TError,
                    Awaited<ReturnType<typeof postControlsNew>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsNew<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof postControlsNew>>,
                    TError,
                    Awaited<ReturnType<typeof postControlsNew>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsNew<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostControlsNew<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getPostControlsNewQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getPostControlsNewSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getPostControlsNewQueryKey(params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof postControlsNew>>
    > = ({ signal }) => postControlsNew(params, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof postControlsNew>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostControlsNewSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof postControlsNew>>
>;
export type PostControlsNewSuspenseQueryError = AxiosError<unknown>;

export function usePostControlsNewSuspense<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params: undefined | PostControlsNewParams,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsNewSuspense<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostControlsNewSuspense<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostControlsNewSuspense<
    TData = Awaited<ReturnType<typeof postControlsNew>>,
    TError = AxiosError<unknown>,
>(
    params?: PostControlsNewParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof postControlsNew>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getPostControlsNewSuspenseQueryOptions(
        params,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postControlsNextOccurrence = (
    controlSchedulingAndSteps: ControlSchedulingAndSteps,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<NextOccurrence>> => {
    return axios.post(
        `/api/controls/next-occurrence`,
        controlSchedulingAndSteps,
        options
    );
};

export const getPostControlsNextOccurrenceMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postControlsNextOccurrence>>,
        TError,
        { data: ControlSchedulingAndSteps },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postControlsNextOccurrence>>,
    TError,
    { data: ControlSchedulingAndSteps },
    TContext
> => {
    const mutationKey = ["postControlsNextOccurrence"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postControlsNextOccurrence>>,
        { data: ControlSchedulingAndSteps }
    > = (props) => {
        const { data } = props ?? {};

        return postControlsNextOccurrence(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostControlsNextOccurrenceMutationResult = NonNullable<
    Awaited<ReturnType<typeof postControlsNextOccurrence>>
>;
export type PostControlsNextOccurrenceMutationBody = ControlSchedulingAndSteps;
export type PostControlsNextOccurrenceMutationError = AxiosError<unknown>;

export const usePostControlsNextOccurrence = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postControlsNextOccurrence>>,
            TError,
            { data: ControlSchedulingAndSteps },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postControlsNextOccurrence>>,
    TError,
    { data: ControlSchedulingAndSteps },
    TContext
> => {
    return useMutation(
        getPostControlsNextOccurrenceMutationOptions(options),
        queryClient
    );
};
export const getControlsResourceCount = (
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ControlResourceCount>> => {
    return axios.get(`/api/controls/resource-count`, options);
};

export const getGetControlsResourceCountQueryKey = () => {
    return [`/api/controls/resource-count`] as const;
};

export const getGetControlsResourceCountQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof getControlsResourceCount>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlsResourceCountQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsResourceCount>>
    > = ({ signal }) => getControlsResourceCount({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getControlsResourceCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsResourceCountQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsResourceCount>>
>;
export type GetControlsResourceCountQueryError = AxiosError<unknown>;

export function useGetControlsResourceCount<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsResourceCount>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsResourceCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsResourceCount<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getControlsResourceCount>>,
                    TError,
                    Awaited<ReturnType<typeof getControlsResourceCount>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsResourceCount<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsResourceCount<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetControlsResourceCountQueryOptions(options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetControlsResourceCountSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof getControlsResourceCount>>,
            TError,
            TData
        >
    >;
    axios?: AxiosRequestConfig;
}) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetControlsResourceCountQueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getControlsResourceCount>>
    > = ({ signal }) => getControlsResourceCount({ signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getControlsResourceCount>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetControlsResourceCountSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getControlsResourceCount>>
>;
export type GetControlsResourceCountSuspenseQueryError = AxiosError<unknown>;

export function useGetControlsResourceCountSuspense<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsResourceCountSuspense<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetControlsResourceCountSuspense<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetControlsResourceCountSuspense<
    TData = Awaited<ReturnType<typeof getControlsResourceCount>>,
    TError = AxiosError<unknown>,
>(
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getControlsResourceCount>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions =
        getGetControlsResourceCountSuspenseQueryOptions(options);

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
